/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiResponseModel } from 'types/common'
import {
  AllowChangeTemProductModel,
  ProductModel,
  ProductRequestModel,
} from 'types/products'
import axiosInstance from './axios'

const productApis = {
  getList: (params?: ProductRequestModel) =>
    axiosInstance.get<any, ApiResponseModel<Array<ProductModel>>>(
      'getProduct',
      {
        params,
      }
    ),
  updateAllowTemChange: (payload: AllowChangeTemProductModel) =>
    axiosInstance.post<any, ApiResponseModel<any>>(
      '/updateallowchangetemproduct',
      payload
    ),
  syncData: () =>
    axiosInstance.post('/insertProduct', {
      updateType: 'updateProduct',
    }),
}

export default productApis
